<template>
  <div>
    <b-button
      variant="outline-light"
      v-on:click="editDetay()"
      size="sm"
      style="padding: 0px"
    >
      <Icon
        icon="material-symbols:edit-outline"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'DÜZENLE'"
        class="text-warning"
      />
    </b-button>
    <b-button
      variant="outline-light"
      v-on:click="deleteDetay()"
      size="sm"
      style="padding: 0px"
    >
      <Icon
        icon="material-symbols:delete-outline"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'SİL'"
        color="#EA5455"
      />
    </b-button>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon,
  },
  methods: {
    editDetay() {
      this.$root.$emit("editEslesenStok", this.params.data);
    },
    deleteDetay() {
      this.$root.$emit("deleteEslesenStok", this.params.data);
    },
  },
};
</script>
